import {
    Map,
    MapLayers,
    MapTileLayer,
    MapMarkerLayer,
    MapShapeLayer,
} from "@progress/kendo-react-map";
import useApiTrigger from "../hooks/useApiTrigger";
import Box from '@mui/material/Box';
import '../../../styles/components/_MapComponent.scss';

const tileSubdomains = ["a", "b", "c"];
const tileUrl = (e) => `https://${e.subdomain}.tile.openstreetmap.org/${e.zoom}/${e.x}/${e.y}.png`;
const attribution ='&copy; <a href="https://osm.org/copyright">OpenStreetMap contributors</a>';
const routeStyle = {
    stroke: {
        color: "#3c72e7ff",  
        width: 5,
        opacity: 0.95
    }
};

export const MapComponent = ({ config, filters }) => {
    const { markers } = useApiTrigger(config, filters);
    if (!markers || markers.length === 0) {
        return (
            <Box className="map-wrapper">
                <Map center={[4.5709, -74.2973]} zoom={6} className="styled-map">
                    <MapLayers>
                        <MapTileLayer
                            urlTemplate={tileUrl}
                            subdomains={tileSubdomains}
                            attribution={attribution}
                        />
                    </MapLayers>
                </Map>
            </Box>
        );
    }

    const routeCoordinates = markers.map(m => [m[1], m[0]]);
    const routeLine = {
        type: "LineString",
        coordinates: routeCoordinates
    };

    const mapCenter = markers.length > 0 ? markers[0] : [4.5709, -74.2973];
    const mapZoom = markers.length === 1 ? 14 : markers.length < 10 ? 10 : 7;

    return (
        <Box className="map-wrapper">
            <Map
                center={mapCenter}
                zoom={mapZoom}
                className="styled-map"
            >
                <MapLayers>
                    <MapTileLayer urlTemplate={tileUrl} subdomains={tileSubdomains} attribution={attribution} />
                    {markers.length > 1 && <MapShapeLayer data={[routeLine]} style={routeStyle} />}
                    <MapMarkerLayer
                        data={markers.map((m, index) => ({
                            latlng: m,
                            name: `Punto ${index + 1}\nLat: ${m[0].toFixed(5)}, Lng: ${m[1].toFixed(5)}`
                        }))}
                        locationField="latlng"
                        titleField="name"
                    />
                </MapLayers>
            </Map>
        </Box>
    );
};